componentRegistryInstance.register('password', 'edit', 'hrd.components.form.PasswordComponent');

hrd.components.form.PasswordComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.PasswordComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		field.prop('type', 'password');
	}
});